export const OFFERS = { label: 'Ofertas', value: 'ofertas' };
export const NEW_ARRIVALS = { label: 'Nuevos ingresos', value: 'nuevos-ingresos' };
export const MOST_SELLED = { label: 'Más destacados', value: 'mas-destacados' };

export const sectionsArray = [MOST_SELLED, OFFERS];
